export default __webpack_public_path__ + "static/media/img-0704-belgium-full-face.36c6e641.png";